export default function WorkEntryTable({ entries, loading, onEdit, onDelete }) {
  if (loading) {
    return (
      <div className="retro-panel text-center py-12">
        <div className="text-2xl glow-text" style={{ color: '#FF6B00' }}>
          [LOADING DATA...]
        </div>
        <div className="text-xl mt-4 blink" style={{ color: '#ffffff' }}>
          &gt;_
        </div>
      </div>
    );
  }

  if (entries.length === 0) {
    return (
      <div className="retro-panel text-center py-12">
        <div className="text-2xl glow-text" style={{ color: '#ffffff' }}>
          [NO ENTRIES FOUND]
        </div>
        <div className="text-lg mt-4" style={{ color: '#FF6B00' }}>
          > CREATE YOUR FIRST WORK ENTRY
        </div>
      </div>
    );
  }

  return (
    <div className="retro-panel overflow-x-auto">
      <h2 className="text-3xl font-bold mb-6 glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
        [WORK ENTRIES] - TOTAL: {entries.length}
      </h2>

      <div className="overflow-x-auto">
        <table className="retro-table" data-testid="entries-table">
          <thead>
            <tr>
              <th>DATE</th>
              <th>DAY</th>
              <th>START</th>
              <th>STOP</th>
              <th>CUSTOMER</th>
              <th>JOB</th>
              <th>HOURS</th>
              <th>TYPE</th>
              <th>COMPLETED</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td>{entry.date}</td>
                <td>{entry.day}</td>
                <td style={{ color: '#FF6B00' }}>{entry.start_time}</td>
                <td style={{ color: '#FF6B00' }}>{entry.stop_time}</td>
                <td style={{ color: '#ffffff', fontWeight: 700 }}>{entry.customer_name}</td>
                <td style={{ color: 'rgba(255, 255, 255, 0.8)' }}>{entry.job_description.substring(0, 50)}...</td>
                <td style={{ color: '#FF6B00', fontWeight: 700 }}>{entry.hours_worked}h{entry.warranty_parent_id && <div className="text-xs text-cyan-300" data-testid={`entry-warranty-billing-${entry.id}`}>Non-billable warranty</div>}</td>
                <td
                  style={{
                    color: entry.work_type === 'remote' ? '#ffffff' : '#FF6B00',
                    fontWeight: 700
                  }}
                >
                  {entry.work_type.toUpperCase()}
                </td>
                <td style={{ color: 'rgba(255, 255, 255, 0.8)' }}>{entry.work_completed.substring(0, 50)}...</td>
                <td>
                  <div className="flex gap-2">
                    <button
                      onClick={() => onEdit(entry)}
                      data-testid={`edit-entry-${entry.id}`}
                      className="px-3 py-1 text-sm border-2 font-semibold"
                      style={{
                        color: '#ffffff',
                        borderColor: '#ffffff',
                        background: 'transparent',
                        boxShadow: '0 0 5px rgba(255, 255, 255, 0.3)'
                      }}
                    >
                      EDIT
                    </button>
                    <button
                      onClick={() => onDelete(entry.id)}
                      data-testid={`delete-entry-${entry.id}`}
                      className="px-3 py-1 text-sm border-2 font-semibold"
                      style={{
                        color: '#FF6B00',
                        borderColor: '#FF6B00',
                        background: 'transparent',
                        boxShadow: '0 0 5px rgba(255, 107, 0, 0.3)'
                      }}
                    >
                      DEL
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}